import PropTypes from 'prop-types';
import { Cart } from 'components/Cart/Cart';
import { PaymentForm } from 'components/Payment/PaymentForm/PaymentForm';
import { PaymentPageProvider } from 'components/Payment/PaymentPageProvider';

export const PaymentPage = (props) => {
  const { showTotal, Order: initialOrderFromPayload } = props;

  return (
    <PaymentPageProvider initialOrderFromPayload={initialOrderFromPayload}>
      <div className="container">
        <Cart currentCartModel={props} stepName="Payment" showTotal={showTotal} />
      </div>
      <PaymentForm {...props} />
    </PaymentPageProvider>
  );
};

PaymentPage.propTypes = {
  stepName: PropTypes.string,
  showTotal: PropTypes.bool,
  Order: PropTypes.object,
};

export const PaymentPageSC = (props) => {
  const { sitecoreData } = props;
  return <PaymentPage {...sitecoreData} />;
};

PaymentPageSC.propTypes = {
  sitecoreData: PropTypes.object,
};
